import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { SnackbarContent } from 'notistack';

export const QueueNotification = React.forwardRef(
  ({ id, message, title, type, closeSnackbar }, ref) => {
    const handleClose = () => closeSnackbar(id);

    return (
      <SnackbarContent role="alert" ref={ref}>
        <Alert
          variant="filled"
          severity={type}
          onClose={handleClose}
          sx={{
            fontSize: 17,
            borderRadius: 2,
            width: '100%',
            maxHeight: 600,
            display: 'flex',
            justifyContent: 'space-between',
            fontWeight: 'normal',
          }}>
          <AlertTitle sx={{ fontSize: 18 }}>{title}</AlertTitle>
          {message}
        </Alert>
      </SnackbarContent>
    );
  }
);

QueueNotification.displayName = 'QueueNotification';
